import {useSelector} from 'react-redux';

import {STEPS} from '../../constants/checkout';
import {getCurrentStep} from '../../store/selectors/currentStep/currentStep';
import {getTaxTotal} from '../../store/selectors/orderReviewTotals/orderReviewTotals';
import {useGetIsUserWithAddress} from '../useGetIsUserWithAddress/useGetIsUserWithAddress';

/**
 * Hook for getting boolean state of show TBD
 */
export const useGetIsShowTBD = () => {
    const step = useSelector(getCurrentStep);
    const isUserWithAddress = useGetIsUserWithAddress();
    const taxTotal = useSelector(getTaxTotal);

    return step === STEPS.DELIVERY_STEP && !isUserWithAddress && taxTotal.price === 0;
};
